module.exports = __webpack_public_path__ + "static/img/coupon_invalid.39b3db6.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/movie/coupon_invalid.png
// module id = b+m4
// module chunks = 1